import * as constants from '../constants/actions';
import * as storage from '../persistance/storage';

const initialState = {
  jewelryFilter: {},
  jewelryResults: null,
  jewelryResultsCount: 0,
  selectedJewelry: null,
  selectedList: [],
  lastResultsPosition: 0,
  resultsList: true,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
  	case constants.JEWELRY_FILTER_SAVE:
      return filterSave(state, action);
    case constants.JEWELRY_SAVE:
      return jewelrySave(state, action);
    case constants.JEWELRY_SAVE_SELECTED:
      return jewelrySaveSelected(state, action);
    case constants.JEWELRY_SET_LAST_POSITION:
      return jewelrySetLastPosition(state, action);
    case constants.JEWELRY_TOGGLE_LIST:
      return jewelryToggleList(state, action);
	  default:
	    return state;
  }
}

function filterSave(state, action) {
  const newFilters = Object.assign({}, state, {
    jewelryFilter: action.filters,
  });
  return newFilters;
}

function jewelrySave(state, action) {
  return Object.assign({}, state, {
    jewelryResults: action.jewelry,
    jewelryResultsCount: action.count,
  });
}

function jewelrySaveSelected(state, action) {
  return Object.assign({}, state, {
    selectedList: action.jewelry,
  });
}

function jewelrySetLastPosition(state, action) {
  return Object.assign({}, state, {
    lastResultsPosition: action.scrollPos,
  });
}

function jewelryToggleList(state, action) {
  return Object.assign({}, state, {
    resultsList: !state.resultsList,
  });
}